import { createContext, useContext } from "react";
import { toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Default context with noop functions (avoiding unused parameter warning)
const ToastContext = createContext({
  successToast: () => {},
  errorToast: () => {},
  infoToast: () => {},
  warningToast: () => {},
});

export const ToastProvider = ( {children}) => {
  const toastOptions= {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
  };

  const successToast = (msg) =>
    toast.success(msg, {
      ...toastOptions,
      style: { 
        backgroundColor: "#1C2270", 
        color: "#fff",
        "--toastify-icon-color-success": "#fff",
        "--toastify-color-progress-success": "#fff",
      },
    });

  const errorToast = (msg) =>
    toast.error(msg, {
      ...toastOptions,
      style: { 
        backgroundColor: "#E2201B", 
        color: "#fff",
        "--toastify-icon-color-error": "#fff",
        "--toastify-color-progress-error": "#fff",
      },
    });

  const infoToast = (msg) =>
    toast.info(msg, {
      ...toastOptions,
      style: { 
        "--toastify-icon-color-info": "#fff",
        "--toastify-color-progress-info": "#fff",
      },
    });

  const warningToast = (msg) =>
    toast.warning(msg, {
      ...toastOptions,
      style: { 
        "--toastify-icon-color-warning": "#fff",
        "--toastify-color-progress-warning": "#fff",
      },
    });

  return (
    <ToastContext.Provider
      value={{ successToast, errorToast, infoToast, warningToast }}
    >
      {children}
      <ToastContainer />
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);